import { colors } from '@peachjar/components';
import { css } from 'react-emotion';

const { prussian, platinum } = colors;

export const styles = {
  wrapper: css`
    background-color: #fff;
    border-radius: 3px;
    padding: 5rem 3rem 3rem 3rem;
  `,
  numberedRowWrapper: css`
    min-height: 30vh;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/containers/IntroduceParentsTab.css.js